const LOG_PREFIX = '[NonCustodialBalance]';

export const logNonCustodialBalance = (step, payload = {}) => {
  console.log(LOG_PREFIX, step, payload);
};

export const warnNonCustodialBalance = (step, payload = {}) => {
  console.warn(LOG_PREFIX, step, payload);
};

export const errorNonCustodialBalance = (step, payload = {}) => {
  console.error(LOG_PREFIX, step, payload);
};
